import React from 'react';
import { Edit2, Trash2, ExternalLink, CheckSquare, Square } from 'lucide-react';
import { fmt } from './constants';

export function ProductTable({ filtered, loading, selectedIds, onToggleSelect, onToggleSelectAll, onEdit, onDelete }) {
  return (
    <div className="bg-white border border-[#E5E5E5]">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#E5E5E5] bg-[#F9F9F9]">
              <th className="px-3 py-4 w-10">
                <button onClick={onToggleSelectAll} className="text-[#AAAAAA] hover:text-[#D4AF37] transition-colors" data-testid="select-all-btn">
                  {selectedIds.size > 0 && selectedIds.size === filtered.length
                    ? <CheckSquare size={16} className="text-[#D4AF37]" />
                    : <Square size={16} />}
                </button>
              </th>
              <th className="px-5 py-4 text-left text-[10px] uppercase tracking-[0.2em] font-semibold text-[#999999] font-work">Product</th>
              <th className="px-5 py-4 text-left text-[10px] uppercase tracking-[0.2em] font-semibold text-[#999999] font-work hidden md:table-cell">Category</th>
              <th className="px-5 py-4 text-left text-[10px] uppercase tracking-[0.2em] font-semibold text-[#999999] font-work">HEIR LUXX Price</th>
              <th className="px-5 py-4 text-left text-[10px] uppercase tracking-[0.2em] font-semibold text-[#999999] font-work hidden sm:table-cell">Status</th>
              <th className="px-5 py-4 text-left text-[10px] uppercase tracking-[0.2em] font-semibold text-[#999999] font-work">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="px-5 py-16 text-center">
                <div className="w-6 h-6 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto" />
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-5 py-12 text-center text-sm text-[#999999] font-work">No products found</td></tr>
            ) : filtered.map(p => (
              <tr key={p.product_id}
                className={`border-b border-[#F3F3F3] hover:bg-[#FAFAFA] transition-colors ${!p.is_active ? 'opacity-40' : ''} ${selectedIds.has(p.product_id) ? 'bg-[#D4AF37]/5' : ''}`}
                data-testid={`product-row-${p.product_id}`}>
                <td className="px-3 py-4 w-10">
                  <button onClick={() => onToggleSelect(p.product_id)} className="text-[#AAAAAA] hover:text-[#D4AF37] transition-colors" data-testid={`select-${p.product_id}`}>
                    {selectedIds.has(p.product_id)
                      ? <CheckSquare size={16} className="text-[#D4AF37]" />
                      : <Square size={16} />}
                  </button>
                </td>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-12 bg-[#F3F3F3] overflow-hidden flex-shrink-0">
                      <img src={p.images?.[0]} alt="" className="object-cover w-full h-full"
                        onError={e => { e.target.style.display = 'none'; }} />
                    </div>
                    <div>
                      <p className="text-[10px] font-semibold text-[#D4AF37] font-work">{p.designer}</p>
                      <p className="text-sm text-[#0A0A0A] font-work max-w-[160px] truncate">{p.name}</p>
                    </div>
                  </div>
                </td>
                <td className="px-5 py-4 hidden md:table-cell">
                  <p className="text-xs text-[#555555] font-work">{p.category}</p>
                  <p className="text-[10px] text-[#AAAAAA] font-work">{p.gender}</p>
                </td>
                <td className="px-5 py-4">
                  <p className="text-sm font-semibold text-[#0A0A0A] font-work">{fmt(p.final_price)}</p>
                  <p className="text-[10px] text-[#D4AF37] font-work">{p.discount_percentage}% off</p>
                </td>
                <td className="px-5 py-4 hidden sm:table-cell">
                  <span className={`text-[10px] uppercase tracking-wider px-2 py-1 font-work font-semibold ${p.is_active ? 'bg-[#2E7D32]/10 text-[#2E7D32]' : 'bg-red-50 text-red-500'}`}>
                    {p.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    {p.source_url && (
                      <a href={p.source_url} target="_blank" rel="noopener noreferrer"
                        title="Open source website"
                        className="text-[#AAAAAA] hover:text-[#D4AF37] transition-colors"
                        data-testid={`source-link-${p.product_id}`}>
                        <ExternalLink size={13} />
                      </a>
                    )}
                    <button onClick={() => onEdit(p)} title="Edit"
                      data-testid={`edit-product-${p.product_id}`}
                      className="text-[#D4AF37] hover:text-[#0A0A0A] transition-colors">
                      <Edit2 size={14} />
                    </button>
                    <button onClick={() => onDelete(p)} title="Remove"
                      data-testid={`delete-product-${p.product_id}`}
                      className="text-[#DDDDDD] hover:text-red-500 transition-colors">
                      <Trash2 size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
